<template>
  <div class="message-box" v-show="isShowMessageBox">
    <div class="message-content">
      <div class="message-content-center-header-font">{{dialogInfo.content}}</div>
      <div class="dialog-footer">
          <div class="left-button" @click="restart">{{dialogInfo.leftText}}</div>
          <div class="right-button" @click="coninute">{{dialogInfo.rightText}}</div>
      </div>
    </div>
  </div>
<!--  <div class="message-box" v-show="isShowMessageBox">-->
<!--    <div class="mask"></div>-->
<!--    <div class="message-content">-->
<!--      &lt;!&ndash; <img :style="{width: iconWidth, height: iconHeight}" :src="iconUrl" alt="">-->
<!--      <p>{{content}}</p> &ndash;&gt;-->
<!--      <div class="dialog">-->
<!--        <p class="content">{{dialogInfo.content}}</p>-->
<!--        <span slot="footer" class="dialog-footer">-->
<!--          <el-button class="left-button" type="primary" @click="restart">{{dialogInfo.leftText}}</el-button>-->
<!--          <el-button class="right-button" type="primary" @click="coninute">{{dialogInfo.rightText}}</el-button>-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
export default {
  props: {
    // content: {
    //   type: String,
    //   default: () => {
    //     return "";
    //   }
    // },
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          content: "",
          leftText: "",
          rightText: ""
        };
      }
    },
    // iconUrl: {
    //   type: Object,
    //   default: () => {
    //     return null;
    //   }
    // },
    // iconWidth: {
    //   type: String,
    //   default: () => {
    //     return "0.38125rem";
    //   }
    // },
    // iconHeight: {
    //   type: String,
    //   default: () => {
    //     return "0.38125rem";
    //   }
    // }
  },
  data() {
    return {
      isShowMessageBox: false,
      resolve: "",
      reject: "",
      promise: "" // 保存promise对象
    };
  },
  methods: {
    // 确定,将promise断定为resolve状态
    restart: function () {
      console.log(" ---- sdad ---");
      this.isShowMessageBox = false;
      //   if (this.isShowInput) {
      //     this.resolve(this.inputValue);
      //   } else {
      this.resolve("confirm");
      //   }
      this.remove();
    },
    // 取消,将promise断定为reject状态
    coninute: function () {
      this.isShowMessageBox = false;
      this.reject("cancel");
      this.remove();
    },
    // 弹出messageBox,并创建promise对象
    showMsgBox: function () {
      this.isShowMessageBox = true;
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      // 返回promise对象
      return this.promise;
    },
    closeBox: function () {
      this.isShowMessageBox = false;
      this.remove();
    },
    remove: function () {
      setTimeout(() => {
        this.destroy();
      }, 300);
    },
    destroy: function () {
      // this.$destroy();
      // document.body.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss" scoped>
.message-box {
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,0.6);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10000;
  user-select: none;
  //.mask {
  //  background: rgba(0,0,0,0.6);
  //  position: fixed;
  //  top: 0;
  //  left: 0;
  //  bottom: 0;
  //  right: 0;
  //  z-index: 50000;
  //  //background: rgba(0, 0, 0, 0.5);
  //}
  .message-content {
    width: var(--width-489);
    height: var(--height-176);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: var(--padding-x-24);
    border-radius: var(--border-radius-6);
    border: var(--width-1) solid var(--color-gray-line-light);
    background: var(--color-white-base);
    box-shadow: 0 var(--margin-x-12) var(--margin-y-40) 0 rgba(0, 0, 0, 0.1);
    z-index: 50001;
    &-center-header-font {
      font-size: var(--font-size-h6);
      color: #1D2129;
      line-height: var(--font-line-height-m);
      font-weight: var(--font-weight-l);
    }
    .dialog-footer {
      display: flex;
      justify-content: flex-end;

      @mixin button-default {
        height: var(--height-40);
        border-radius: var(--width-20);
        font-size: var(--font-size-m);
        line-height: var(--font-line-height-m);
        padding: var(--padding-y-8) var(--padding-x-16);
        cursor: pointer;
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .left-button{
        @include button-default;
        margin-right: var(--margin-x-16);
        border: var(--width-2) solid var(--color-blue-active);
        color: var(--color-blue-active);
      }
      .right-button {
        @include button-default;
        background: var(--color-blue-active);
        color: var(--color-white-base);
      }
    }
    //position: fixed;
    //box-sizing: border-box;
    //display: flex;
    //flex-direction: row;
    //justify-content: center;
    //align-items: center;
    //padding: 0.1875rem 0.15625rem;
    //// min-height: 0.96875rem;
    //left: 50%;
    //top: 50%;
    //transform: translate(-50%, -50%);
    //border-radius: 0.4em;
    //background: #fff;
    //z-index: 50001;
    // img {
    //   width: 0.38125rem;
    //   height: 0.38125rem;
    //   animation: rubberBand;
    //   animation-duration: 2s;
    //   animation-iteration-count: infinite;
    // }
    // p {
    //   font-size: 0.1rem;
    //   color: #0c121c;
    //   font-weight: 500;
    //   margin-left: 0.125rem;
    // }
  }
}

//.dialog {
//  display: flex;
//  flex-direction: column;
//  justify-content: center;
//  align-items: center;
//  border-radius: 100px;
//  width: 3.75rem;
//  padding: 0.125rem 0;
//}
//.dialog-footer {
//  display: flex;
//  flex-direction: row;
//}
//.content {
//  font-size: 0.125rem;
//  font-weight: 500;
//  color: #2e2e2e;
//  line-height: 30px;
//  margin-bottom: 0.1875rem;
//}
//.left-button {
//  margin: 0 0.1875rem;
//  width: 0.925rem;
//  height: 0.2875rem;
//  border-radius: 0.14375rem;
//  // border: none;
//  background-color: #ffffff !important;
//  color: #5867fe;
//  &:hover {
//    color: #5867fe !important;
//    background-color: #eef0fe !important;
//  }
//}
//.right-button {
//  margin: 0 0.1875rem;
//  width: 0.925rem;
//  height: 0.2875rem;
//  border-radius: 0.14375rem;
//  border: none;
//  background-color: #5867fe !important;
//}
///deep/ .el-button {
//  padding: 0px;
//}
//// .button {
////   width: 150px;
////   margin-bottom: 20px;
////   border-radius: 24px;
//// }
///deep/ .el-dialog__header {
//  padding: 0;
//}
///deep/ .el-dialog__body {
//  display: flex;
//  flex-direction: row;
//  justify-content: center;
//  align-items: center;
//}
///deep/ .el-dialog__footer {
//  display: flex;
//  flex-direction: row;
//  justify-content: center;
//}
</style>



// WEBPACK FOOTER //
// src/components/abiltyBeginDialogNew/index.vue